import CloseCircle from "@zenith/assets/icons/CloseCircle";
import FinopayLogo from "@zenith/assets/icons/FinopayLogo";
import { AppNavigation } from "@zenith/hooks";
import { DASHBOARD, SIGN_IN } from "@zenith/routes/paths";
import { ACCESS, REFRESH } from "@zenith/data/constants";

/* eslint-disable-next-line */
export interface ErrorHandlerPageProps {
  reload?: boolean;
}

export function ErrorHandlerPage(props: ErrorHandlerPageProps) {
  const navigation = props.reload ? null : AppNavigation();
  const year = new Date().getFullYear();

  const isLoggedIn = Boolean(
    sessionStorage.getItem(ACCESS) && sessionStorage.getItem(REFRESH)
  );

  const handleRedirect = () => {
    if (window.location.pathname === (isLoggedIn ? DASHBOARD : SIGN_IN)) {
      window.location.reload();
      return;
    }

    if (isLoggedIn) {
      navigation?.navigateTo(DASHBOARD);
    } else {
      navigation?.navigateTo(SIGN_IN);
    }
  };

  const handleReload = () => {
    window.location.reload();
  };

  return (
    <div className="flex min-h-screen flex-col items-center justify-between bg-[#fff] px-4 pt-10 text-center">
      <FinopayLogo />

      <div className="flex flex-col items-center gap-5 px-10 sm:px-0 md:w-1/2 lg:w-1/3">
        <div className="rounded-full bg-[#F3B8B340] p-8">
          <CloseCircle width="50" height="50" className="1" />
        </div>

        <h2 className="mt-5 text-3xl font-semibold text-gray-900">
          Server Error
        </h2>
        <p className="mb-3 w-full text-base text-[#626262]">
          Something is not quite right on our end. Our team has been notified,
          and we are working to fix it as quickly as possible.
        </p>

        <hr className="my-4 w-full border-gray-300" />

        <ul className="w-full text-start text-[#626262]">
          <li className="flex items-center space-x-4">
            <CloseCircle width="24" height="24" className="1" />
            <span>Refresh the page and try again.</span>
          </li>
          <li className="mt-4 flex items-center space-x-4">
            <CloseCircle width="24" height="24" className="1" />
            <span>Check your internet connection.</span>
          </li>
          <li className="mt-4 flex items-center space-x-4">
            <CloseCircle width="24" height="24" className="1" />
            <span>If the issue persists, contact support.</span>
          </li>
        </ul>

        <div className="mt-10 mb-5 flex w-full flex-col flex-wrap gap-3 md:flex-row">
          <button
            id="account-dashboard-button"
            className="secondary-button flex-1"
            onClick={props.reload ? handleReload : handleRedirect}
          >
            Go to Home page
          </button>
          <button
            id="account-dashboard-button"
            className="primary-button flex-1"
            onClick={handleReload}
          >
            Refresh Page
          </button>
        </div>
      </div>

      <p className="mb-6 text-sm text-[#9B9B9B]">© Finopay By Zenith {year}</p>
    </div>
  );
}

export default ErrorHandlerPage;
